import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import { HomeAssistantView } from '@/ts/HococoInterfaces';
import { Mutations } from '@/ts/store/Constants';
import UserInquiryType from '@/ts/UserInquiryType';
import UserInquiryCategory from '@/ts/UserInquiryCategory';
import UserInquiry from '@/ts/UserInquiry';

@Module({name: 'HomeAssistant', namespaced: true})
export default class HomeAssistant extends VuexModule {
    public homeAssistantVisibility: boolean = false;
    public homeAssistantMainView: string = 'TypesView';
    public currentHomeAssistantView: string = this.homeAssistantMainView;
    public prevHomeAssistantView: string = this.homeAssistantMainView;
    public activeType: UserInquiryType = null;
    public activeCategory: UserInquiryCategory = null;
    public activeInquiry: UserInquiry = null;
    public searchQuery: string = '';
    public homeAssistantViews: HomeAssistantView[] = [
        { component: 'TypesView', resetMutations: [], prevComponent: this.homeAssistantMainView },
        { component: 'CategoriesView', resetMutations: [Mutations.SET_ACTIVE_HOME_ASSISTANT_TYPE], prevComponent: this.homeAssistantMainView },
        { component: 'QuestionsView', resetMutations: [Mutations.SET_ACTIVE_HOME_ASSISTANT_CATEGORY], prevComponent: 'CategoriesView' },
        { component: 'SearchResultsView', resetMutations: [], prevComponent: this.homeAssistantMainView},
    ];

    @Mutation
    public RESET_HOME_ASSISTANT_STORE_STATE() {
        this.homeAssistantVisibility  = false;
        this.homeAssistantMainView    = 'TypesView';
        this.currentHomeAssistantView = 'TypesView';
        this.prevHomeAssistantView    = 'TypesView';
        this.activeType               = null;
        this.activeCategory           = null;
        this.activeInquiry            = null;
        this.searchQuery              = '';

        this.homeAssistantViews = [
            { component: 'TypesView', resetMutations: [], prevComponent: this.homeAssistantMainView },
            { component: 'CategoriesView', resetMutations: [Mutations.SET_ACTIVE_HOME_ASSISTANT_TYPE], prevComponent: this.homeAssistantMainView },
            { component: 'QuestionsView', resetMutations: [Mutations.SET_ACTIVE_HOME_ASSISTANT_CATEGORY], prevComponent: 'CategoriesView' },
            { component: 'SearchResultsView', resetMutations: [], prevComponent: this.homeAssistantMainView},
        ];
    }

    get getHomeAssistantVisibility(): boolean {
        return this.homeAssistantVisibility;
    }

    get getActiveType(): UserInquiryType {
        return this.activeType;
    }

    get getActiveCategory(): UserInquiryCategory {
        return this.activeCategory;
    }

    get getActiveInquiry(): UserInquiry {
        return this.activeInquiry;
    }

    get getHomeAssistantMainViews(): HomeAssistantView {
        return this.homeAssistantViews.find((view: HomeAssistantView) => view.component === this.homeAssistantMainView);
    }

    get getCurrentHomeAssistantViews(): HomeAssistantView {
        return this.homeAssistantViews.find((view: HomeAssistantView) => view.component === this.currentHomeAssistantView);
    }

    get getPrevHomeAssistantViews(): string {
        return this.prevHomeAssistantView;
    }

    get getHomeAssistantViews(): HomeAssistantView[] {
        return this.homeAssistantViews;
    }

    get getSearchQuery(): string {
        return this.searchQuery;
    }

    @Mutation
    public SET_HOME_ASSISTANT_VISIBILITY(visibility: boolean) {
        this.homeAssistantVisibility = visibility;
    }

    @Mutation
    public SET_HOME_ASSISTANT_CURRENT_VIEW(view: string) {
        this.currentHomeAssistantView = view;
    }

    @Mutation
    public SET_HOME_ASSISTANT_PREV_VIEW(view: string) {
        this.prevHomeAssistantView = view;
    }

    @Mutation
    public SET_ACTIVE_HOME_ASSISTANT_TYPE(type: UserInquiryType) {
        this.activeType = type;
    }

    @Mutation
    public SET_ACTIVE_HOME_ASSISTANT_CATEGORY(category: UserInquiryCategory) {
        this.activeCategory = category;
    }

    @Mutation
    public SET_ACTIVE_HOME_ASSISTANT_INQUIRY(inquiry: UserInquiry) {
        this.activeInquiry = inquiry;
    }

    @Mutation
    public SET_HOME_ASSISTANT_SEARCH_QUERY_VALUE(value: string): void {
        this.searchQuery = value;
    }
}
